/* eslint-disable max-len */
/* eslint-disable no-undef */
import { setAdManagerInitialized } from '../../actions/adv'
import store from '../..'
import { getSecretFeatureToggle } from '../../../utils/i18n/secret'
import { selectUserCookiesPreferenceActive } from '../../selectors/tracking'
import { OT_TARGETING_ADS_PREFERENCE } from '../../../helpers/const'
import { getCampaignDataFromUrl } from '../../../helpers/getInfoFromUrl'

function onLoadAdv() {
  const state = store.getState()
  const { country } = getCampaignDataFromUrl()

  const CookiesPreferencesNeeded = getSecretFeatureToggle('AD_MANAGER_CATEGORY_PERSONALIZED_ADS')(country)
  const isTargetingAdsCookieEnable = selectUserCookiesPreferenceActive(OT_TARGETING_ADS_PREFERENCE)(state)
  const requestNonPersonalizedAds = !(CookiesPreferencesNeeded && isTargetingAdsCookieEnable === true)

  window.googletag = window.googletag || {}
  window.googletag.cmd = googletag.cmd || []

  googletag.cmd.push(() => {
    /**
     * Requesting non personalized ADS.
     * Verify that an ad tag is requesting non-personalized ads by finding
     * the ad request in your browser developer tools and looking for the
     * parameter &npa=1.
     * Calling setRequestNonPersonalizedAds(0) or
     * setting requestNonPersonalizedAds=0 will re-activate personalization.
     */

    googletag.pubads().setRequestNonPersonalizedAds(+requestNonPersonalizedAds)

    googletag.enableServices()
  })

  /**
   * Set state.adv.isAdManagerInitialized === TRUE.
   * No adv request is fired until the script is ready
   */
  store.dispatch(setAdManagerInitialized(true))
}

export function initAdv() {
  /**
   * Loading the ADV script on the document BODY,
   * asynchronously and with an onLoad callback
   */
  const googleScript = document.createElement('script')
  googleScript.type = 'text/javascript'
  googleScript.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
  googleScript.setAttribute('async', true)
  googleScript.onload = onLoadAdv
  document.body.appendChild(googleScript)
}
